import { useLayoutEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import routeConfig from "./routes/routeConfig.json";
import appConfig from "./routes/posts/apps/appConfig.json";
import useAuthContext from "./hooks/useAuthContext.js";
import IndexPage from "./routes/index.js";
import LoadingSpinner from "./components/LoadingSpinner/loadingSpinner.js";

import CTC from "./routes/posts/caseStudies/ctc/index.jsx";
import CMB from "./routes/posts/caseStudies/cmb/index.jsx";
import CX from "./routes/posts/caseStudies/cx/index.jsx";
import EXTRAMED from "./routes/posts/caseStudies/extramed/index.jsx";
import T2A from "./routes/posts/caseStudies/t2a/index.jsx";

const Wrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return children;
};

export default function App() {
  const { auth, logout } = useAuthContext();

  const posts = Object.keys(routeConfig)
    .filter((post) => routeConfig[post].isDraft !== true)
    .sort(function (a, b) {
      return new Date(routeConfig[b].date) - new Date(routeConfig[a].date);
    })
    .map((el) => routeConfig[el]);

  const apps = Object.keys(appConfig)
    .filter((app) => appConfig[app].isDraft !== true)
    .map((el) => appConfig[el]);

  const postComponents = {
    ctc: <CTC />,
    cx: <CX />,
    cmb: <CMB />,
    extramed: <EXTRAMED />,
    t2a: <T2A />,
  };

  if (auth.loading) {
    return (
      <div className="flex h-screen">
        <div className="m-auto">
          <LoadingSpinner />
        </div>
      </div>
    );
  }
  return (
    <Wrapper>
      <Routes>
        <Route
          path="/"
          element={
            <IndexPage posts={posts} auth={auth} logout={logout} apps={apps} />
          }
        />
        {Object.keys(postComponents).map((post, idx) => (
          <Route
            key={idx}
            path={routeConfig[post].slug}
            element={postComponents[post]}
          />
        ))}
        {/* {Object.keys(routeConfig).map((route, idx) => (
          <Route
            key={idx}
            path={routeConfig[route].slug}
            element={
              require(`./routes/posts/caseStudies/${route}/index.js`).default
            }
          ></Route>
        ))} */}
        <Route
          path="*"
          element={
            <main style={{ padding: "1rem" }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Routes>
    </Wrapper>
  );
}
